import { Command } from "@ckeditor/ckeditor5-core";

export default class InsertSymbolCommand extends Command {
  /**
   * Inserts a single character at the current selection.
   *
   * @param {Object} options
   * @param {String} options.character The character to insert.
   */
  execute({ character } = {}) {
    // Only an omitted character is ignored. An empty string is a configuration
    // mistake rather than a "nothing to insert" case, so it is not swallowed
    // here - it reaches `insertText` where it is visible while debugging.
    if (character === null || character === undefined) {
      return;
    }

    // The `insertText` command (typing) already handles replacing a non
    // collapsed selection, undo batching, selection attributes and the track
    // changes integration, so the character is inserted through it rather than
    // written to the model directly.
    this.editor.execute("insertText", { text: character });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;

    // `getFirstPosition()` returns null for degenerate selection states (for
    // example while the editor is being destroyed), and `findAllowedParent()`
    // dereferences the position without checking.
    const position = selection.getFirstPosition();

    if (!position) {
      this.isEnabled = false;
      return;
    }

    const allowedIn = model.schema.findAllowedParent(position, "$text");

    this.isEnabled = allowedIn !== null;
  }
}
